// Centralized branding — change BRAND.* here and it propagates everywhere
// (nav wordmark, login, document title). Generic, not strategy-specific.
export const BRAND = {
  name: "Helm",
  wordmark: "HELM",
  tagline: "Risk-balanced portfolio command.",
  blurb: "Monitor your strategy, simulate allocations by risk, and run your book.",
  features: ["Monitor", "Simulate", "Execute"],
};

// A minimalist ship's-wheel mark (a helm). Inherits color via currentColor.
export function Mark({ size = 24 }) {
  const s = size, c = s / 2, r = s * 0.32, hub = s * 0.085, out = r + s * 0.13;
  const ang = (i) => (Math.PI / 3) * i;            // 6 spokes / handles
  const ln = (i, r1, r2) => ({
    x1: (c + Math.cos(ang(i)) * r1).toFixed(2), y1: (c + Math.sin(ang(i)) * r1).toFixed(2),
    x2: (c + Math.cos(ang(i)) * r2).toFixed(2), y2: (c + Math.sin(ang(i)) * r2).toFixed(2),
  });
  return (
    <svg width={size} height={size} viewBox={`0 0 ${s} ${s}`} aria-hidden="true" style={{ display: "block" }}>
      <circle cx={c} cy={c} r={r} fill="none" stroke="currentColor" strokeWidth={s * 0.075} />
      {[0, 1, 2, 3, 4, 5].map((i) => <line key={`s${i}`} {...ln(i, hub, r)} stroke="currentColor" strokeWidth={s * 0.055} />)}
      {[0, 1, 2, 3, 4, 5].map((i) => <line key={`h${i}`} {...ln(i, r, out)} stroke="currentColor" strokeWidth={s * 0.07} strokeLinecap="round" />)}
      <circle cx={c} cy={c} r={hub} fill="currentColor" />
    </svg>
  );
}
